import React, { Component } from "react";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import Footer from "../Footerpage/Footer";
import CMSTranslationFile from "../Footerpage/Credits_Translation_Corp.json";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import "./Credits.css";
import TranslationFile from "../Translation/Translation_corp.json";
import { Helmet } from "react-helmet";

let userSelectedLanguage;

class Credits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditList: []
    };
  }

  scrollToContactUs() {
    this.props.callBack();
  }

  componentWillMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");
    window.scrollTo(0, 0);

    this.setState({
      creditList: [
        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.magnific.com/free-photo/blue-print-with-laptop-copy-space_6413502.htm"
                title="Blue print with laptop and copy space"
              >
                Blue print with laptop and copy space
              </a>{" "}
              by Magnific
            </>
          )
        },
        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                title="Receipt animated icons"
                href="https://www.flaticon.com/free-animated-icons/receipt"
              >
                Receipt animated icons
              </a>{" "}
              created by Magnific - Flaticon
            </>
          )
        },

        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.magnific.com/free-photo/woman-working-with-finances-table-laptop-smartphone-money-notepad_14203171.htm"
                title="Woman working with finances on table with laptop, smartphone, money and notepad"
              >
                Image by frimufilms
              </a>
              on Magnific
            </>
          )
        },

        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.flaticon.com/free-animated-icons/process"
                title="Process animated icons"
              >
                Process animated icons
              </a>{" "}
              created by Magnific - Flaticon
            </>
          )
        },

        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.flaticon.com/free-animated-icons/pdf"
                title="PDF animated icons"
              >
                Pdf animated icons
              </a>{" "}
              created by Magnific - Flaticon
            </>
          )
        },

        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.flaticon.com/free-animated-icons/approval"
                title="invoice animated Icon"
              >
                Invoice animated icons
              </a>{" "}
              created by Magnific - Flaticon
            </>
          )
        },

        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.flaticon.com/free-animated-icons/declined"
              >
                Declined animated icons
              </a>{" "}
              created by Magnific - Flaticon
            </>
          )
        },
        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.flaticon.com/free-animated-icons/approval"
              >
                Approval animated icons
              </a>
              created by Magnific - Flaticon
            </>
          )
        },

        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.magnific.com/free-photo/businessmen-hands-white-table-with-documents-drafts_7514916.htm"
              >
                Image by cookie_studio
              </a>{" "}
              on Magnific
            </>
          )
        },

        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.magnific.com/free-vector/hand-drawn-remote-recruitment-illustration_79310663.htm"
              >
                Image by pikisuperstar
              </a>{" "}
              on Magnific
            </>
          )
        },

        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.magnific.com/free-vector/mini-people-with-bulb-light-idea_5713888.htm"
              >
                Image by studiogstock
              </a>{" "}
              on Magnific
            </>
          )
        },

        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.magnific.com/free-photo/computer-security-with-login-password-padlock_34131578.htm#fromView=keyword&page=1&position=0&uuid=40942bcc-1908-41b1-aae8-71e8c378661d&query=Unlock+secure+4+pin+password+png"
              >
                Image by upklyak
              </a>{" "}
              on Magnific
            </>
          )
        },
        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.magnific.com/free-photo/online-survey-3d-render-laptop-form-with-ticks_33525390.htm#fromView=search&page=1&position=8&uuid=3d644411-89fe-4fd5-9cba-550f08fb6010&track=ais_hybrid&query=forms+and+laptop+animation"
              >
                Image by upklyak
              </a>{" "}
              on Magnific
            </>
          )
        },

        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://icons8.com/icon/zYQDIb6UB5Pk/test-account"
              >
                Test Account
              </a>{" "}
              icon by{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://icons8.com"
              >
                Icons8
              </a>
            </>
          )
        },
        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://icons8.com/icon/13925/logout"
              >
                Log Out
              </a>{" "}
              icon by{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://icons8.com"
              >
                Icons8
              </a>
            </>
          )
        },
        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://icons8.com/icon/49973/add-list"
              >
                Add List
              </a>{" "}
              icon by{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://icons8.com"
              >
                Icons8
              </a>
            </>
          )
        },
        {
          name: (
            <>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://icons8.com/icon/9eLeuKay1etl/form"
              >
                Form
              </a>{" "}
              icon by{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://icons8.com"
              >
                Icons8
              </a>
            </>
          )
        }
      ]
    });
  }

  callback = () => {
    this.setState({
      reRender: true
    });
  };

  render() {
    const { creditList } = this.state;

    console.log(creditList, ">");
    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            {userSelectedLanguage == "sw"
              ? TranslationFile.FaviconAppText[userSelectedLanguage]
              : TranslationFile.FaviconAppText.en}
          </title>
        </Helmet>

        <HeaderNavBar isCorpPortal={true} />
        <div className="credits-div">
          <br></br>
          <div
            style={{
              // fontWeight: 700,
              // fontSize: "30px",
              textAlign: "center"
            }}
          >
            {/* Credits */}
            <strong>
              {CMSTranslationFile.Credits_Heading[userSelectedLanguage]}
            </strong>
          </div>
          <br></br>

          <div>
            <section>
              {/* Images : */}
              <strong>
                {CMSTranslationFile.Credits_Images_title[userSelectedLanguage]}
              </strong>
            </section>
            <section>
              {/* Freepik : */}
              <strong>
                {CMSTranslationFile.Credits_Freepik_title[userSelectedLanguage]}
              </strong>
            </section>
            <br></br>
            <br></br>

            {creditList &&
              creditList.length > 0 &&
              creditList.map((i, idx) => {
                return (
                  <div style={{ margin: "4px 10px" }}>
                    <div>
                      {idx + 1} . {i.name}
                    </div>
                    <div>
                      <a href={i.url} target="blank">
                        {i.url}
                      </a>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
        <ScrolltoTop />
        <Footer />
      </div>
    );
  }
}

export default Credits;
